import { render, staticRenderFns } from "./MortgageApplicationsApprovalWrapper.vue?vue&type=template&id=8144db42&scoped=true&"
import script from "./MortgageApplicationsApprovalWrapper.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationsApprovalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationsApprovalWrapper.vue?vue&type=style&index=0&id=8144db42&prod&lang=scss&"
import style1 from "./MortgageApplicationsApprovalWrapper.vue?vue&type=style&index=1&id=8144db42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8144db42",
  null
  
)

export default component.exports